// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { ProviderResponse } from './provider-response';

/** See com.rev360.pms.api.controller.prescription.MedicationPrescriptionListResponse */
/* istanbul ignore next */
@GandalfModel
export class MedicationPrescriptionListResponse extends GandalfModelBase {

	@GandalfConstantDecorator(constants.PrescriptionAuthorizationType)
	@GandalfProperty({ designType: constants.PrescriptionAuthorizationType })
	authorizationType!: constants.PrescriptionAuthorizationType | null;

	@GandalfProperty({ designType: ProviderResponse })
	authorizedBy!: ProviderResponse | null;

	@GandalfProperty({ designType: String })
	authorizingProviderFirstName!: string | null;

	@GandalfProperty({ designType: String })
	authorizingProviderLastName!: string | null;

	@GandalfProperty({ designType: String })
	description!: string | null;

	@GandalfProperty({ designType: String })
	drugCode!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	expirationDate!: Date | null;

	@GandalfProperty({ designType: Number })
	id!: number | null;

	@GandalfProperty({ designType: Boolean })
	isRxNormDrug!: boolean | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	modifiedDate!: Date | null;

	@GandalfProperty({ designType: String })
	primaryProviderFirstName!: string | null;

	@GandalfProperty({ designType: String })
	primaryProviderLastName!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	startDate!: Date | null;

	@GandalfConstantDecorator(constants.PrescriptionStatus)
	@GandalfProperty({ designType: constants.PrescriptionStatus })
	status!: constants.PrescriptionStatus | null;

	@GandalfConstantDecorator(constants.MedicationPrescriptionType)
	@GandalfProperty({ designType: constants.MedicationPrescriptionType })
	type!: constants.MedicationPrescriptionType | null;

	@GandalfProperty({ designType: Boolean })
	useProviderSignature!: boolean | null;

}
